import { render, staticRenderFns } from "./EfsMdArchivesForm.vue?vue&type=template&id=3e5cb4b0&"
import script from "./EfsMdArchivesForm.vue?vue&type=script&lang=js&"
export * from "./EfsMdArchivesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports